/**
 * @generated SignedSource<<1f063c99fd78d303209c9bd4d14b74a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NewsletterFormPart_UserInformationFragment$data = {
  readonly signedUpToNewsletters: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly " $fragmentType": "NewsletterFormPart_UserInformationFragment";
};
export type NewsletterFormPart_UserInformationFragment$key = {
  readonly " $data"?: NewsletterFormPart_UserInformationFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"NewsletterFormPart_UserInformationFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NewsletterFormPart_UserInformationFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Newsletter",
      "kind": "LinkedField",
      "name": "signedUpToNewsletters",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserInformation",
  "abstractKey": null
};

(node as any).hash = "c1ed5d1d5c7c794b4f17f3670dc6245a";

export default node;
